<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mb-10 max-w-4xl">
      <div class="text-center">
        <div class="sm:flex justify-center">
          <img
            class="block w-64"
            src="@/assets/access-control.svg"
            alt="Etiquetas"
          >
          <div
            class="text-4xl font-bold text-center sm:my-20"
          >
            Gestiona las <span class="text-purple-500">reglas</span> de acceso
          </div>
        </div>
      </div>
      <a
        v-if="!isCreating"
        class="sm:w-64 cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md my-5 hover:bg-purple-400"
        @click="isCreating = true"
      >
        <eva-icon
          name="plus-outline"
          fill="#FFFFFF"
        />
        <div
          class="block-inline w-full"
        >
          Nueva regla
        </div>
      </a>
      <access-rule-card
        v-if="isCreating"
        :creating="true"
        @close="isCreating = false"
      />
      <h1
        v-if="Object.keys(rules).length > 0"
        class="text-lg pb-4"
      >
        Reglas existentes:
      </h1>
      <div v-else>
        <img
          class="mx-auto sm:w-3/6 w-10/12 opacity-25"
          src="@/assets/empty.svg"
          alt="Empty"
        >
        <div class="mt-4 text-lg text-center">
          ¡Vaya! Parece que aún no cuentas con reglas, anímate a crear la primera.
        </div>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <access-rule-card
          v-for="rule in sortedRules"
          :key="rule.id"
          :rule="rule"
        />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import moment from 'moment-timezone'
import { db } from '../utils/firebase'

import accessRuleCard from '../components/accessRuleCard'

export default {
  components: {
    accessRuleCard,
  },
  data () {
    return {
      isCreating: false,
      name: '',
      rules: {},
      rulesBind: null,
    }
  },
  computed: {
    columns () {
      return [
        {
          prop: 'name',
          name: 'Regla',
          size: 120,
        },
        {
          prop: 'tagIDs',
          name: 'Etiquetas',
          size: 300,
          cellTemplate: (createElement, props) => {
            const tagIDs = typeof props.model[props.prop] !== 'undefined' ? Object.keys(props.model[props.prop]) : []
            return createElement('div', {},
              tagIDs.map(tagID => {
                if (typeof this.tags[tagID] === 'undefined' && tagID.indexOf('+') === -1) return ''
                return createElement('span', {
                  class: {
                    'rounded-md': true,
                    'bg-purple-500': true,
                    'text-white': true,
                    'py-1': true,
                    'px-2': true,
                    'mr-2': true,
                  },
                }, tagID.indexOf('+') > -1 ? tagID : this.tags[tagID])
              }))
          },
          editor: 'tags',
        },
        {
          prop: 'condition',
          name: 'Condición',
          size: 120,
        },
        {
          prop: 'days',
          name: 'Días',
          size: 300,
          cellTemplate: (createElement, props) => {
            const days = typeof props.model[props.prop] !== 'undefined' ? Object.keys(props.model[props.prop]) : []
            return createElement('div', {},
              days.map(day => {
                if (typeof this.days[day] === 'undefined' && day.indexOf('+') === -1) return ''
                return createElement('span', {
                  class: {
                    'rounded-md': true,
                    'bg-purple-500': true,
                    'text-white': true,
                    'py-1': true,
                    'px-2': true,
                    'mr-2': true,
                  },
                }, day.indexOf('+') > -1 ? day : this.days[day])
              }))
          },
          editor: 'tags',
        }
      ]
    },
    sortedRules () {
      return Object.values(this.rules).sort((a, b) => {
        return b.timestamp.toMillis() - a.timestamp.toMillis()
      })
    },
    ...mapState({
      instanceID: state => state.admin.instanceID,
      persons: state => state.admin.persons,
      instancesInfo: state => state.auth.instancesInfo,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  mounted () {
    if (this.rulesBind === null) {
      this.rulesBind = db.collection('instances').doc(this.instanceID).collection('rules').onSnapshot(snap => {
        if (!snap.empty) {
          snap.docChanges().forEach(change => {
            if (change.type === 'added' || change.type === 'modified') {
              this.$set(this.rules, change.doc.id, {
                id: change.doc.id,
                ...change.doc.data(),
              })
            } else {
              this.$delete(this.rules, change.doc.id)
            }
          })
        } else {
          this.rules = {}
        }
      }, (err) => { console.info(err.code) })
    }
  },
  beforeDestroy () {
    if (this.rulesBind !== null) this.rulesBind()
  },
}
</script>
